import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Autocomplete from '@mui/material/Autocomplete';
import { ComponentPropsWithoutRef, ReactNode, useMemo } from 'react';
import { STATES } from 'src/constants/states';
import { PaymentTextField } from 'src/pages/payment-msi/PaymentMsiV2/components/PaymentTextField';

type State = (typeof STATES)[number];

interface StatesAutocompleteProps {
  onBlur?: ComponentPropsWithoutRef<typeof Autocomplete>['onBlur'];
  selectedState: string;
  onStateChange: (newState: string) => void;
  name: string;
  disabled?: boolean;
  required?: boolean;
  label: ReactNode;
  error?: boolean;
  helperText?: string;
}

const statesAutocompleteStyles = {
  root: {
    '> div:nth-of-type(2)': {
      height: '3.5rem',
    },
    "> div:nth-of-type(3) div[tabIndex='-1']": {
      padding: '1rem 1rem',
    },
    width: '100%',
  },
};

export function StatesAutocomplete({
  onStateChange,
  onBlur,
  selectedState,
  name,
  disabled,
  label,
  required,
  error,
  helperText,
}: StatesAutocompleteProps) {
  const currentValue =
    useMemo(() => {
      return STATES.find((state) => state.value === selectedState);
    }, [selectedState]) || null;

  function onChange(_event: unknown, value: State) {
    onStateChange(value.value);
  }

  return (
    <Autocomplete
      sx={statesAutocompleteStyles.root}
      onBlur={onBlur}
      value={currentValue as State}
      onChange={onChange}
      disableClearable={true}
      options={STATES}
      disabled={disabled}
      popupIcon={<KeyboardArrowDownIcon />}
      renderInput={(props) => {
        return (
          <PaymentTextField
            {...props}
            required={required}
            label={label}
            name={name}
            error={error}
            helperText={helperText}
          />
        );
      }}
    />
  );
}
